<template>
  <figure class="image-lazy-load">
    <img
      v-bind="$attrs"
      :class="{
        'image-lazy-load__image': true,
        'image-lazy-load__image--loaded': isLoaded,
      }"
      loading="lazy"
      @load="handleImageLoaded"
    >
    <loader-icon
      v-if="shouldDisplayLoader"
      class="image-lazy-load__spinner"
    />
  </figure>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import LoaderIcon from '@monolith/legacy/components/loader-icon.vue';

const emit = defineEmits<{
  loaded: [value: HTMLImageElement];
}>();

const props = withDefaults(
  defineProps<{
    animationDuration?: number;
  }>(),
  {
    animationDuration: 650,
  }
);

const cssAnimationDuration = computed(() => `${props.animationDuration}ms`);

const shouldDisplayLoader = ref<boolean>(true);
const isLoaded = ref<boolean>(false);

const handleImageLoaded = (event: Event) => {
  emit('loaded', event.target as HTMLImageElement);
  isLoaded.value = true;
  setTimeout(() => {
    shouldDisplayLoader.value = false;
  }, props.animationDuration);
};
</script>

<style scoped lang="scss">
.image-lazy-load {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 1;

  &__image {
    z-index: 1;
    opacity: 0;
    transition: opacity v-bind(cssAnimationDuration) ease-in-out;
    &--loaded {
      opacity: 1;
    }
  }

  &__spinner {
    z-index: 0;
    position: absolute;
  }
}
</style>
